<div class="receipt-header" [class.branded-bg]="branding?.headerImageUrl || branding?.headerBase64">
  <ng-container *ngIf="branding?.headerImageUrl || branding?.headerBase64; else defaultHeader">
    <!-- Background Image Template -->
    <img [src]="branding?.headerBase64 || branding?.headerImageUrl" class="header-template-bg" aria-hidden="true" alt="" />
    
    <!-- Left Side Brand Overlay -->
    <div class="header-logo-overlay" 
         [style.left.%]="branding?.headerLogoLeft !== undefined ? branding?.headerLogoLeft : 6"
         [style.top.%]="branding?.headerLogoTop !== undefined ? branding?.headerLogoTop : 15"
         [style.width.%]="branding?.headerLogoWidth !== undefined ? branding?.headerLogoWidth : 10"
         [style.height.%]="branding?.headerLogoHeight !== undefined ? branding?.headerLogoHeight : 70"
         *ngIf="vendorDetails?.logo">
      <ng-container *ngTemplateOutlet="companyLogoTemplate"></ng-container>
    </div>

    <!-- Company Name — vertically centered -->
    <div class="header-brand-overlay"
         [style.left.%]="branding?.headerNameLeft !== undefined ? branding?.headerNameLeft : 18"
         style="top: 50%;">
      <h1 class="overlay-company-name">{{ vendorDetails?.companyName || 'Company Name' }}</h1>
      <p class="overlay-company-tagline" *ngIf="vendorDetails?.tagline">{{ vendorDetails.tagline }}</p>
    </div>

     <div class="header-contact-overlay"
          [style.left.%]="branding?.headerContactLeft !== undefined ? branding?.headerContactLeft : 68"
          [style.top.%]="branding?.headerContactTop !== undefined ? branding?.headerContactTop : 20"
          [style.width.%]="branding?.headerContactWidth !== undefined ? branding?.headerContactWidth : 30"
          [style.--theme-color]="branding?.themeColor || '#ffffff'">
      <div class="overlay-contact-row" *ngIf="vendorDetails?.address">
        <i class="fa-solid fa-location-dot contact-icon"></i>
        <span class="contact-text">{{ vendorDetails.address }}</span>
      </div>
      <div class="overlay-contact-row" *ngIf="vendorDetails?.phone">
        <i class="fa-solid fa-phone contact-icon"></i>
        <span class="contact-text">{{ vendorDetails.phone }}</span>
      </div>
      <div class="overlay-contact-row" *ngIf="vendorDetails?.fax">
        <i class="fa-solid fa-fax contact-icon"></i>
        <span class="contact-text">{{ vendorDetails.fax }}</span>
      </div>
      <div class="overlay-contact-row" *ngIf="vendorDetails?.email">
        <i class="fa-solid fa-envelope contact-icon"></i>
        <span class="contact-text">{{ vendorDetails.email }}</span>
      </div>
      <div class="overlay-contact-row" *ngIf="vendorDetails?.website">
        <i class="fa-solid fa-globe contact-icon"></i>
        <span class="contact-text">{{ vendorDetails.website }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #defaultHeader>
    <div class="erp-document-header">
      <!-- Left Column: Logo or Company Name -->
      <div class="erp-header-left">
        <div class="erp-header-logo" *ngIf="vendorDetails?.logo; else textCompanyName">
          <ng-container *ngTemplateOutlet="companyLogoTemplate"></ng-container>
        </div>
        <ng-template #textCompanyName>
          <h1 class="erp-header-company-name">{{ vendorDetails?.companyName || 'Company Name' }}</h1>
        </ng-template>
      </div>

      <!-- Right Column: TEL, EMAIL, WEB, TRN -->
      <div class="erp-header-right">
        <div class="erp-meta-item" *ngIf="vendorDetails?.phone">
          <span class="meta-label">TEL:</span>
          <span class="meta-value">{{ vendorDetails.phone }}</span>
        </div>
        <div class="erp-meta-item" *ngIf="vendorDetails?.fax">
          <span class="meta-label">FAX:</span>
          <span class="meta-value">{{ vendorDetails.fax }}</span>
        </div>
        <div class="erp-meta-item" *ngIf="vendorDetails?.email">
          <span class="meta-label">EMAIL:</span>
          <span class="meta-value">{{ vendorDetails.email }}</span>
        </div>
        <div class="erp-meta-item" *ngIf="vendorDetails?.website">
          <span class="meta-label">WEB:</span>
          <span class="meta-value">{{ vendorDetails.website }}</span>
        </div>
        <div class="erp-meta-item" *ngIf="vendorDetails?.trn">
          <span class="meta-label">TRN:</span>
          <span class="meta-value">{{ vendorDetails.trn }}</span>
        </div>
      </div>
    </div>
    <div class="erp-header-bottom-divider"></div>
  </ng-template>

  <!-- Reusable Logo Template Snippet -->
  <ng-template #companyLogoTemplate>
    <img *ngIf="vendorDetails?.logo" [src]="vendorDetails.logo" alt="Logo" class="shared-logo-img" />
  </ng-template>

</div>